import { render, staticRenderFns } from "./InformationDisplay.vue?vue&type=template&id=08edbc82&scoped=true"
import script from "./InformationDisplay.vue?vue&type=script&lang=js"
export * from "./InformationDisplay.vue?vue&type=script&lang=js"
import style0 from "./InformationDisplay.vue?vue&type=style&index=0&id=08edbc82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edbc82",
  null
  
)

export default component.exports